module.exports = __webpack_public_path__ + "static/hyperv_29.4448a202.jpg";